import React, { useState } from 'react'

import Button from '../Button/Button'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'
import Announcement from '../../assets/announcement.svg'

import './Spotlight.css'
import Modal from '../Modal/Modal'

export const Spotlight = () => {
  const { restaurantInfo } = useRestaurant()
  const [ modalShown, setModalShown ] = useState(false)
  const { data, loading, error } = restaurantInfo
  const openModal = () => setModalShown(true)
  const closeModal = () => setModalShown(false)

  if (loading || error) return null
  const { restaurant: { spotlightConfig: { headerText, bodyText } } } = data

  if (!headerText) return null

  return (
    <React.Fragment>
      <header styleName='spotlight' role='banner'>
        <Announcement height='18px' width='15px' />
        <p styleName='text'>
          {headerText}
        </p>
        {bodyText && <button styleName='moreLink' onClick={openModal}>More</button>}
      </header>
      {modalShown && <Modal onClose={closeModal}>
        <div styleName='modalBody'>
          <div styleName='announcement'>
            <Announcement width='42px' height='35px' />
          </div>
          <p styleName='header'>{headerText}</p>
          <p styleName='body'>{bodyText}</p>
          <Button onClick={closeModal} style='linkWide'>Back To Menu</Button>
        </div>
      </Modal>}

    </React.Fragment>
  )
}
